/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import clsx from "clsx";
import { BandCreditCardProps, allBands, objectPrefixBands, getCardFlag } from "./data";

function BandCreditCard({ cartNumber, selectedBand }: BandCreditCardProps) {
  const [copySelectedBand, setCopySelectedBand] = useState(objectPrefixBands[selectedBand]);

  useEffect(() => {
    setCopySelectedBand(objectPrefixBands[getCardFlag(cartNumber ?? "")]);
  }, [setCopySelectedBand, selectedBand, cartNumber]);

  return (
    <Box className="flex flex-col relative overflow-hidden w-full">
      {allBands.map((band, index) => {
        const bandSelected = index === copySelectedBand?.index;
        return (
          <Box
            className={clsx(
              "transition-all duration-500 overflow-hidden",
              bandSelected ? (index === 0 ? "h-20 md:h-12" : "h-18 md:h-10") : "h-0"
            )}
          >
            <img
              className={clsx(index === 0 ? "h-20 md:h-12" : "h-18 md:h-10")}
              src={band?.bandUrl}
              alt={band?.value}
              key={index}
            />
          </Box>
        );
      })}
    </Box>
  );
}

export default BandCreditCard;
